<div class="cb-empty-state-container">
  <div class="cb-empty-state-illustration">
    <img [src]="illustration()" />
  </div>
  <div class="cb-empty-state-text">
    <h2>{{ title() }}</h2>
    @if(subtitle()){
    <p>{{ subtitle() }}</p>
    }
  </div>
  <div class="cb-empty-state-controls">
    <ng-content></ng-content>
  </div>
</div>